import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import "../Styles/emlak-genel.css";
import QuickAlert from "./QuickAlert";

// eslint-disable-next-line react/prop-types
const ContactPopup = ({ isOpen, onClose, messageTo }) => {
  const textareaRef = useRef(null);
  const popupRef = useRef(null);
  const [phone, setPhone] = useState("");
  const [nameSurname, setNameSurname] = useState("");
  const [iletisimNedeni, setIletisimNedeni] = useState("");
  const [aciklama, setAciklama] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalIcerik, setModalIcerik] = useState("");
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, []);

  const handleTextareaChange = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  // Format phone number as user types
  const handlePhoneChange = (e) => {
    const input = e.target.value;

    // Remove all non-digit characters
    const digitsOnly = input.replace(/\D/g, "");

    // Limit to 10 digits (Turkish mobile numbers without country code)
    const truncated = digitsOnly.substring(0, 10);

    // Format the phone number as user types (XXX XXX XX XX)
    let formatted = "";
    if (truncated.length > 0) {
      formatted = truncated.replace(
        /(\d{3})(\d{0,3})(\d{0,2})(\d{0,2})/,
        (_, p1, p2, p3, p4) => {
          let result = p1;
          if (p2) result += " " + p2;
          if (p3) result += " " + p3;
          if (p4) result += " " + p4;
          return result;
        }
      );
    }

    setPhone(formatted);
  };

  // Validate form before submission
  const handleSubmit = (e) => {
    e.preventDefault();

    const phoneDigits = phone.replace(/\D/g, "");
    if (phoneDigits.length !== 10) {
      alert("Lütfen geçerli bir telefon numarası giriniz (5XX XXX XX XX)");
      return;
    }
    if (
      nameSurname.length === 0 ||
      iletisimNedeni.length === 0 ||
      aciklama.length === 0
    ) {
      alert("Lütfen verileri eksiksiz doldurunuz.");
    }
    fetch(`${process.env.REACT_APP_API_URL}/api/messages/set-message`, {
      method: "POST",
      body: JSON.stringify({
        fullName: nameSurname,
        phone: phoneDigits,
        type: iletisimNedeni,
        message: aciklama,
        messageTo: messageTo ? messageTo : null,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          setModalIcerik("Çok istek atıldı 15 dakika sonra tekrar deneyiniz.");
          setModalTitle("Hata");
          setShowModal(true);
          return response.json().then((err) => {
            return Promise.resolve();
          });
        }
        return response.json();
      })
      .then((result) => {
        if (result["m"] == "basarili") {
          setPhone("");
          setNameSurname("");
          setIletisimNedeni("");
          setAciklama("");
          setModalIcerik("Mesajınız iletilmiştir.");
          setModalTitle("Başarılı");
          setShowModal(true);
        }
        if (result["m"] == "se") {
          setModalIcerik("Sunucu hatası.");
          setModalTitle("Hata");
          setShowModal(true);
        }
        if (result["m"] == "sce") {
          setModalIcerik("Sunucu hatası.");
          setModalTitle("Hata");
          setShowModal(true);
        }
        if (result["m"] == "Too many requests!") {
          setModalIcerik("Çok istek atıldı 15 dakika sonra tekrar deneyiniz.");
          setModalTitle("Hata");
          setShowModal(true);
        }
      })
      .catch((e) => {
        //Hata
      });
  };

  const handleOverlayClick = (e) => {
    if (popupRef.current && !popupRef.current.contains(e.target)) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="popup-overlay" onClick={handleOverlayClick}>
        <div className="popup-container" ref={popupRef}>
          <div className="popup-header">
            <h3>RBA ile Al Sat Kirala</h3>
            <button className="close-button" onClick={onClose}>
              &times;
            </button>
          </div>
          <div className="popup-content">
            <form
              id="contact-form"
              action=""
              method="post"
              onSubmit={handleSubmit}
            >
              <div className="row">
                <div className="col-lg-12 mb-3">
                  <label htmlFor="name" className="form-label">
                    Ad Soyad
                  </label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Adınız Soyadınız..."
                    autoComplete="on"
                    value={nameSurname}
                    onChange={(e) => {
                      setNameSurname(e.target.value);
                    }}
                    required
                    className="form-control"
                  />
                </div>
                <div className="col-lg-12 mb-3">
                  <label htmlFor="phone" className="form-label">
                    Telefon Numarası
                  </label>
                  <div className="phone-input-group">
                    <span className="phone-prefix">+90</span>
                    <input
                      type="tel"
                      name="phone"
                      id="phone"
                      placeholder="5XX XXX XX XX"
                      autoComplete="on"
                      required
                      className="form-control"
                      value={phone}
                      onChange={handlePhoneChange}
                    />
                  </div>
                  <small
                    style={{
                      color: "#666",
                      marginTop: "5px",
                      display: "block",
                      fontSize: "0.75rem",
                    }}
                  >
                    Örnek: 5XX XXX XX XX
                  </small>
                </div>
                <div className="col-lg-12 mb-3">
                  <label htmlFor="subject" className="form-label">
                    İletişim Nedeni
                  </label>
                  <select
                    name="subject"
                    id="subject"
                    required
                    className="form-control"
                    value={iletisimNedeni}
                    onChange={(e) => {
                      setIletisimNedeni(e.target.value);
                    }}
                  >
                    <option value="" disabled selected>
                      Seçiniz...
                    </option>
                    <option value="satin-alma">Satın alma</option>
                    <option value="kiralama">Kiralama</option>
                    <option value="satis">Satış</option>
                    <option value="kiraya-verme">Kiraya verme</option>
                  </select>
                </div>
                <div className="col-lg-12 mb-3">
                  <label htmlFor="message" className="form-label">
                    Açıklama
                  </label>
                  <textarea
                    name="message"
                    id="message"
                    placeholder="Mesajınız..."
                    className="form-control"
                    rows="1"
                    ref={textareaRef}
                    value={aciklama}
                    onChange={(e) => {
                      setAciklama(e.target.value);
                      handleTextareaChange();
                    }}
                    style={{
                      overflowY: "hidden",
                      resize: "none",
                    }}
                  ></textarea>
                </div>
                <div className="col-lg-12 mt-3">
                  <button
                    type="submit"
                    id="form-submit"
                    className="submit-button"
                  >
                    Gönder
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <QuickAlert
        showModal={showModal}
        setShowModal={setShowModal}
        baslik={modalTitle}
        icerik={modalIcerik}
      />
    </>
  );
};

ContactPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ContactPopup;
